import { render, staticRenderFns } from "./TaskInfo.vue?vue&type=template&id=5a96c9c6&scoped=true&"
import script from "./TaskInfo.vue?vue&type=script&lang=js&"
export * from "./TaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaskInfo.vue?vue&type=style&index=0&id=5a96c9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96c9c6",
  null
  
)

export default component.exports